import { ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { accountFromLocalStorage } from '../../../old-crazy-web-frontend/src/app/utils/account-from-localstorage';

export function firstStepsSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  const account = accountFromLocalStorage();

  return localStorageSync({
    keys: ['currentState', 'statesFlow', 'stateMeta'],
    rehydrate: true,
    storageKeySerializer: key => `${account}_${key}`
  })(reducer);
}
